var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoMini = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.05 460.13",
    style: {
      enableBackground: "new 0 0 426.05 460.13"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4ADBD1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.26,238.87l-1.47-7.37l-4.03-6.01l-5.98-4.05l-7.29-1.5l-7.32,1.5l-5.98,4.05l-4.03,6.01l-1.47,7.37 l1.47,7.34l4.03,6.01l5.98,4.08l7.32,1.5l7.29-1.5l5.98-4.08l4.03-6.01L62.26,238.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.99,238.84l-2.18-10.91l-5.98-8.95l-8.87-6.04l-10.88-2.2l-10.85,2.2l-8.87,6.04l-5.98,8.95l-2.2,10.91 l2.2,10.96l5.98,8.95l8.87,6.01l10.85,2.2l10.88-2.2l8.87-6.01l5.98-8.95L145.99,238.84z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.75,407.55l-1.5-7.37l-4.03-6.01l-5.96-4.05l-7.32-1.5l-7.32,1.5l-5.96,4.05l-4.05,6.01l-1.44,7.37 l1.44,7.37l4.05,6.01l5.96,4.05l7.32,1.5l7.32-1.5l5.96-4.05l4.03-6.01L229.75,407.55z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.75,70.16l-1.5-7.34l-4.03-6.01l-5.96-4.08l-7.32-1.47l-7.32,1.47l-5.96,4.08l-4.05,6.01l-1.44,7.34 l1.44,7.37l4.05,6.01l5.96,4.05l7.32,1.5l7.32-1.5l5.96-4.05l4.03-6.01L229.75,70.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.86,332.93l-2.2-10.94l-5.96-8.92l-8.87-6.04l-10.88-2.2l-10.88,2.2l-8.87,6.04l-5.98,8.92l-2.18,10.94 l2.18,10.96l5.98,8.92l8.87,6.01l10.88,2.23l10.88-2.23l8.87-6.01l5.96-8.92L238.86,332.93z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.86,145.32l-2.2-10.94l-5.96-8.95l-8.87-6.01l-10.88-2.2l-10.88,2.2l-8.87,6.01l-5.98,8.95l-2.18,10.94 l2.18,10.94l5.98,8.95l8.87,6.01l10.88,2.23l10.88-2.23l8.87-6.01l5.96-8.95L238.86,145.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.52,238.87l-2.97-14.74l-8.05-12.02l-11.91-8.13L210.95,201l-14.63,2.96l-11.94,8.13l-8.05,12.02 l-2.94,14.74l2.94,14.72l8.05,12.05l11.94,8.11l14.63,2.96l14.63-2.96l11.91-8.11l8.05-12.05L248.52,238.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.25,238.84l-2.18-10.91l-5.98-8.95l-8.87-6.04l-10.88-2.2l-10.85,2.2l-8.87,6.04l-5.98,8.95l-2.2,10.91 l2.2,10.96l5.98,8.95l8.87,6.01l10.85,2.2l10.88-2.2l8.87-6.01l5.98-8.95L332.25,238.84z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.21,238.87l-1.47-7.37l-4.05-6.01l-5.96-4.05l-7.32-1.5l-7.32,1.5l-5.96,4.05l-4.03,6.01l-1.47,7.37 l1.47,7.34l4.03,6.01l5.96,4.08l7.32,1.5l7.32-1.5l5.96-4.08l4.05-6.01L397.21,238.87z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoMini);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-mini.210db1502e00106599ebf00c0164fdda.svg";